import {Box} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppDialog} from 'components/dialogs';
import {AppTabs, TabsType} from 'components/tabs';
import {AppTooltip} from 'components/toolip';
import {useGetAllBoardSettings} from 'hooks/board';
import {Setting2} from 'iconsax-react';
import {BoardSettingsSettingTabsTypeEnum, SettingModel, TenantSettingsKeysEnum} from 'models/settings';
import {useEffect, useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
import {DynamiclySettingsRendering} from '../common';
import BoardDynamicFrom from './BoardDynamicFrom';
import {BoardFilesSetting, BoardMemberSetting} from './components';
interface SettingsGroupBy {
    [key: string]: SettingModel[];
}
export const BoardSetting = () => {
    const [openBoardSettingDialog, setOpenBoardSettingDialog] = useState(false);
    const {boardId} = useParams();
    const {getAllBoardSettings, getAllBoardSettingsLoading, getAllBoardSettingsResponse} = useGetAllBoardSettings();
    useEffect(() => {
        if (boardId) {
            getAllBoardSettings({
                variables: {
                    boardSlug: boardId,
                },
            });
        }
    }, [boardId]);

    const tabs: TabsType<string>[] = useMemo(() => {
        const response: TabsType<string>[] = [
            {
                title: 'Members',
                key: BoardSettingsSettingTabsTypeEnum.Members,
                component: <BoardMemberSetting />, // Replace with actual component
            },
            {
                title: 'Embedded Form',
                key: BoardSettingsSettingTabsTypeEnum.BoardDynamicForm,
                component: <BoardDynamicFrom />, // Replace with actual component
                permissions: [TenantSettingsKeysEnum.TenantEnableDynamicForm.toString()],
            },
            {
                title: 'Import/Export Data',
                key: BoardSettingsSettingTabsTypeEnum.ImportExportData,
                component: <BoardFilesSetting />, // Replace with actual component
                permissions: [TenantSettingsKeysEnum.TenantEnableImportExport.toString()],
            },
        ];
        const groupedSettings = getAllBoardSettingsResponse?.reduce<SettingsGroupBy>((acc, setting) => {
            const group = setting.groupName || 'Other';
            acc[group] = acc[group] || [];
            acc[group].push(setting);
            return acc;
        }, {});

        // Add the grouped settings tabs only if there are settings
        if (groupedSettings) {
            Object.entries(groupedSettings).forEach(([group, settings]) => {
                response.push({
                    title: group,
                    key: group,
                    component: (
                        <DynamiclySettingsRendering
                            key={group}
                            loading={getAllBoardSettingsLoading}
                            settings={settings}
                            onCloseHanlder={() => {}}
                            shouldUpdateTenantSettings={false}
                            getAllSettingsRequest={() => {
                                if (boardId) {
                                    getAllBoardSettings({
                                        variables: {
                                            boardSlug: boardId,
                                        },
                                    });
                                }
                            }}
                        />
                    ),
                });
            });
        }

        return response;
    }, [getAllBoardSettingsResponse]);

    const handleToggleBoardSettingDialog = () => {
        setOpenBoardSettingDialog(!openBoardSettingDialog);
    };
    return (
        <>
            <Box mx={0.5}>
                <AppTooltip title="Board Settings">
                    <AppIconButton
                        size="medium"
                        onClick={event => {
                            event.stopPropagation();
                            handleToggleBoardSettingDialog();
                        }}
                    >
                        <Setting2 />
                    </AppIconButton>
                </AppTooltip>
            </Box>
            {openBoardSettingDialog && (
                <AppDialog
                    dialogContentProps={{sx: {py: 0}}}
                    open={openBoardSettingDialog}
                    onCloseDialog={handleToggleBoardSettingDialog}
                    title="Board Settings"
                    children={
                        <>
                            <AppTabs selectedTabValue={BoardSettingsSettingTabsTypeEnum.Members} tabs={tabs} />
                        </>
                    }
                    fullWidth
                    maxWidth="md"
                />
            )}
        </>
    );
};

export default BoardSetting;
